<div class="shell">
  <aside class="shell-sidebar">
    <div class="shell-brand">
      <div class="shell-brand__mark">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 2 4 5v6c0 5.2 3.4 9.9 8 11 4.6-1.1 8-5.8 8-11V5l-8-3Z"
            fill="rgba(255,255,255,0.18)"
            stroke="#fff"
            stroke-width="1.6"
          />
          <path
            d="m8.5 12 2.5 2.5 4.5-5"
            stroke="#fff"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div>
        <p class="shell-brand__title">Outward Approval</p>
        <p class="shell-brand__subtitle">Transaction Management</p>
      </div>
    </div>

    <nav class="shell-nav">
      <a routerLink="/queue" routerLinkActive="active">
        <mat-icon>fact_check</mat-icon>
        Queue
      </a>
      @if (isAdmin()) {
        <a routerLink="/staff" routerLinkActive="active">
          <mat-icon>badge</mat-icon>
          Staff
        </a>
      }
    </nav>

    <div class="shell-user">
      @if (session(); as s) {
        <div class="shell-user__avatar">{{ initials() }}</div>
        <div class="shell-user__info">
          <p class="shell-user__email">{{ s.email }}</p>
          <p class="shell-user__role">{{ s.role }}</p>
        </div>
      }
      <button mat-icon-button (click)="logout()" aria-label="Logout" matTooltip="Logout">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </aside>

  <main class="shell-content">
    <router-outlet />
  </main>
</div>
